import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .ios {
    &.segment {
      border-radius: 0;
    }
  }
  .clock-in-button {
    --color-checked: var(--ion-color-success-contrast);
    --background-checked: var(--ion-color-success);
    --indicator-color: var(--ion-color-success-shade);
  }
  .break-button {
    --color-checked: var(--ion-color-warning-contrast);
    --background-checked: var(--ion-color-warning);
    --indicator-color: var(--ion-color-warning-shade);
  }
  .clock-out-button {
    --color-checked: var(--ion-color-danger-contrast);
    --background-checked: var(--ion-color-danger);
    --indicator-color: var(--ion-color-danger-shade);
  }
`;
